import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ClienteDetail } from '../../../../types/cliente';
import { ClienteKycBadge } from '../../components/cliente-kyc-badge';
import { formatDocumento } from '../../components/format';

interface Props {
  detail: ClienteDetail;
}

const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Back = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSecondary};
  text-decoration: none;
  width: max-content;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

const NameBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Name = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Meta = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.secondary};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 14px;
`;

const fullName = (detail: ClienteDetail): string =>
  `${detail.nome ?? ''} ${detail.sobrenome ?? ''}`.trim() || 'Cliente sem nome';

export const ClienteHeader = ({ detail }: Props) => (
  <Header>
    <Back to="/clientes">
      <ArrowLeft size={14} /> Voltar para clientes
    </Back>
    <TopRow>
      <NameBlock>
        <Name>{fullName(detail)}</Name>
        <Meta>
          {detail.email}
          {detail.documento && ` · ${formatDocumento(detail.documento)}`}
        </Meta>
      </NameBlock>
      <ClienteKycBadge
        status={detail.statusKyc}
        description={detail.statusKycDescricao}
      />
    </TopRow>
  </Header>
);
